import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import ForgotPasswordForm from "../forms/ForgotPasswordForm.vue"
import {
  RequestApplicantPasswordResetMutationMutationVariables,
  RequestApplicantPasswordResetMutationMutation,
  RequestApplicantPasswordResetMutation,
} from "@/gql"

import { useMutation } from "@/hooks/useMutation"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  emits: ["goto-login"],
  setup(__props, { emit }) {


const { mutate } = useMutation()
const isSubmitting = ref(false)
const forgotPasswordForm = ref(null)
const success = ref(false)

const { router } = useRouter()
const trackId = router.currentRoute.params.id

const navigateToLogin = () => {
  emit("goto-login")
}

const onSubmit = async (emailAddress: string, resetForm: () => void) => {
  if (!trackId) return
  isSubmitting.value = true
  // Mutate
  const result = await mutate<
    RequestApplicantPasswordResetMutationMutation,
    RequestApplicantPasswordResetMutationMutationVariables
  >({
    mutation: RequestApplicantPasswordResetMutation,
    variables: {
      emailAddress,
      trackId,
    },
    handlePayloadErrors: true,
  })
  // Done
  if (!result?.data?.requestApplicantPasswordReset.error) {
    success.value = true
    resetForm()
  }
  isSubmitting.value = false
}

return { __sfc: true,emit, mutate, isSubmitting, forgotPasswordForm, success, router, trackId, navigateToLogin, onSubmit, ForgotPasswordForm }
}

})